/**
 * Client-side brand lock — only the four canonical Italian brand names.
 * "farmaceutica" (brand) ≠ "farmaceutico/farmaceutici/pharmaceuticals" (sector).
 */
(function () {
  var config = window.__BRAND_NAME_LOCK__;
  if (!config || !config.locale || config.locale.indexOf('it') === 0) return;

  var canonical = config.canonical || {};
  var full = canonical.full || 'Farmaceutica Internazionale Italiana';
  var international = canonical.international || 'Farmaceutica Internazionale';
  var shortName = canonical.short || 'Farmaceutica Italiana';
  var menuLabel = canonical.menu || 'La Farmaceutica';

  function normalize(text) {
    return text
      .toLowerCase()
      .replace(/[\[\]|]/g, ' ')
      .replace(/[.,]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isSector(normalized) {
    return (
      /\bpharmaceuticals\b/.test(normalized) ||
      /\bfarmaceutico\b/.test(normalized) ||
      /\bfarmaceutici\b/.test(normalized) ||
      /\bfarmaceutiche\b/.test(normalized) ||
      /\bwholesaler/.test(normalized) ||
      /\bgrossist/.test(normalized) ||
      /\bdistributor/.test(normalized)
    );
  }

  function hasPharmaSingular(normalized) {
    return /\bpharmaceutical\b/.test(normalized) && !/\bpharmaceuticals\b/.test(normalized);
  }

  var menuExact = {
    contacts: 'Contact',
    contatti: 'Contact',
    'domande frequenti': 'FAQ',
    'frequently asked questions': 'FAQ',
    'the pharmaceutical': menuLabel,
    'the pharmaceutical company': menuLabel
  };

  var enEmbeddedReplacements = [
    [/International Italian Pharmaceutical/g, full],
    [/Italian International Pharmaceutical/g, full],
    [/Pharmaceutical International Italian/g, full],
    [/Pharmaceutical Italian International/g, full],
    [/International Pharmaceutical Italian/g, full],
    [/Italian Pharmaceutical International/g, full]
  ];

  function lockText(text) {
    if (!text || !text.trim()) return text;

    var normalized = normalize(text);
    var wordCount = normalized.split(' ').length;

    if (menuExact[normalized]) {
      return menuExact[normalized];
    }

    if (normalized === 'farmaceutica internazionale italiana' || normalized === 'farmaceutica italiana internazionale') {
      return full;
    }

    if (!isSector(normalized) && wordCount <= 5 && /\binternational\b/.test(normalized) && /\bitalian\b/.test(normalized) && hasPharmaSingular(normalized)) {
      return full;
    }

    if (normalized === 'farmaceutica internazionale') {
      return international;
    }

    if (!isSector(normalized) && wordCount <= 4 && (normalized === 'international pharmaceutical' || normalized === 'international pharmaceutical company')) {
      return international;
    }

    if (normalized === 'farmaceutica italiana') {
      return shortName;
    }

    if (!isSector(normalized) && wordCount <= 4 && (normalized === 'italian pharmaceutical' || normalized === 'italian pharmaceutical company')) {
      return shortName;
    }

    if (normalized === 'la farmaceutica' || normalized === 'the pharmaceutical company' || normalized === 'the pharmaceutical') {
      return menuLabel;
    }

    if (isSector(normalized)) {
      return text;
    }

    var result = text;
    result = result.replace(/The Pharmaceutical Company/gi, menuLabel);
    result = result.replace(/The Pharmaceutical(?!\s+Company)/gi, menuLabel);
    for (var i = 0; i < enEmbeddedReplacements.length; i++) {
      result = result.replace(enEmbeddedReplacements[i][0], enEmbeddedReplacements[i][1]);
    }

    if (/\bfarmaceutica internazionale italiana\b/i.test(normalized) || /\bfarmaceutica italiana internazionale\b/i.test(normalized)) {
      result = result.replace(/\bfarmaceutica internazionale italiana\b/gi, full).replace(/\bfarmaceutica italiana internazionale\b/gi, full);
    } else if (/\bfarmaceutica internazionale\b/i.test(normalized)) {
      result = result.replace(/\bfarmaceutica internazionale\b/gi, international);
    } else if (/\bfarmaceutica italiana\b/i.test(normalized)) {
      result = result.replace(/\bfarmaceutica italiana\b/gi, shortName);
    } else if (/\bla farmaceutica\b/i.test(normalized)) {
      result = result.replace(/\bla farmaceutica\b/gi, menuLabel);
    }

    return result;
  }

  function walkTextNodes(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        if (node.parentElement && ['SCRIPT', 'STYLE', 'NOSCRIPT'].indexOf(node.parentElement.tagName) !== -1) {
          return NodeFilter.FILTER_REJECT;
        }
        if (node.parentElement && node.parentElement.closest && node.parentElement.closest('.notranslate')) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var node;
    while ((node = walker.nextNode())) {
      var locked = lockText(node.nodeValue);
      if (locked !== node.nodeValue) node.nodeValue = locked;
    }
  }

  function lockDataContent(root) {
    root.querySelectorAll('[data-content]').forEach(function (el) {
      var value = el.getAttribute('data-content');
      var locked = lockText(value);
      if (locked !== value) el.setAttribute('data-content', locked);
    });
  }

  function lockAttributes(root) {
    var attrs = ['title', 'alt', 'aria-label', 'content'];
    root.querySelectorAll('*').forEach(function (el) {
      for (var j = 0; j < attrs.length; j++) {
        var attr = attrs[j];
        if (!el.hasAttribute(attr)) continue;
        var value = el.getAttribute(attr);
        var locked = lockText(value);
        if (locked !== value) el.setAttribute(attr, locked);
      }
    });

    if (document.title) {
      var lockedTitle = lockText(document.title);
      if (lockedTitle !== document.title) document.title = lockedTitle;
    }
  }

  function applyBrandLock() {
    if (!document.body) return;
    lockDataContent(document.documentElement);
    walkTextNodes(document.body);
    lockAttributes(document.documentElement);
  }

  applyBrandLock();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyBrandLock);
  }

  window.addEventListener('load', function () {
    applyBrandLock();
    setTimeout(applyBrandLock, 500);
    setTimeout(applyBrandLock, 1500);
  });

  if (typeof MutationObserver !== 'undefined' && document.body) {
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(applyBrandLock, 120);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
})();
